import React from 'react';
import PropTypes from 'prop-types';
import { useSprings, a } from '@react-spring/web';

const TrailAnimation = ({ isValid, delay, children }) => {
  const items = React.Children.toArray(children);
  const time = () => {
    return delay ? 350 : 250;
  };
  const springs = useSprings(
    items.length,
    items.map((item, i) => {
      const delayedTime = time() + 50 * i;
      return {
        from: {
          opacity: 1,
          y: 0,
          position: 'relative',
          visibility: 'visible'
        },
        to: {
          opacity: 0,
          y: -60,
          position: 'relative',
          visibility: 'hidden'
        },
        delay: delayedTime,
        reset: isValid,
        reverse: !isValid
      };
    })
  );

  return springs.map((styles, index) => (
    <a.div key={index} style={styles}>
      {items[index]}
    </a.div>
  ));
};

TrailAnimation.propTypes = {
  isValid: PropTypes.bool.isRequired,
  children: PropTypes.array.isRequired
};

export default TrailAnimation;
